export const T = {
  en_GB: {
    advisorReviewGoalDefault: "This goal requires review by your advisor before submission.",
    advisorReviewVolatilityBreach:
      "The volatility for this goal exceeds the allowed limit. Your advisor needs to resolve this.",
    advisorReviewVolatilityNotAccepted:
      "The volatility deviation for this goal has been rejected by your advisor.",
    advisorReviewEquityShareBreach:
      "The equity share for this goal exceeds the allowed limit. Your advisor needs to resolve this.",
    advisorReviewEquityShareNotAccepted:
      "The equity share deviation for this goal has been rejected by your advisor.",
    // QL-493 — fail-closed cases; the measure stays unnamed for the client.
    advisorReviewNotEvaluable:
      "Your advisor needs to complete the risk check for this goal before submission.",
  },
  nb_NO: {
    advisorReviewGoalDefault: "Dette målet krever gjennomgang av rådgiveren din før innsending.",
    advisorReviewVolatilityBreach:
      "Volatiliteten for dette målet overstiger tillatt grense. Rådgiveren din må løse dette.",
    advisorReviewVolatilityNotAccepted:
      "Volatilitetsavviket for dette målet er avvist av rådgiveren.",
    advisorReviewEquityShareBreach:
      "Aksjeandelen for dette målet overstiger tillatt grense. Rådgiveren din må løse dette.",
    advisorReviewEquityShareNotAccepted:
      "Aksjeandelsavviket for dette målet er avvist av rådgiveren.",
    advisorReviewNotEvaluable:
      "Rådgiveren din må fullføre risikosjekken for dette målet før innsending.",
  },
} as const;
